<template>
<div class="d-flex ga-3 flex-wrap align-start justify-space-between">
    <availability-info-nibblet :availability="product.availability">
        <template #additional v-if="time">
            <div class="d-inline-flex align-center ml-2 ga-2">
                <v-icon :icon="mdiTimerSandEmpty"></v-icon>
                <vue-countdown v-if="counting" @end="counting = false" :time="time" v-slot="{hours, minutes, seconds}">{{$t('eshop::product-details.expedition_end')}} {{hours ? `${hours} h `: ''}}{{minutes}} min</vue-countdown>
            </div>
        </template>
    </availability-info-nibblet>
    <div class="d-inline-flex align-center">
        <v-btn
            variant="text"
            :prepend-icon="mdiMessageTextOutline"
            class="h-auto text-body-2 text-decoration-underline px-0 to-warning"
            color="grey-darken-1"
            style="margin-top: 2px"
        >
            {{$t('eshop::product-details.query')}}
            <v-dialog
                v-model="dialog"
                activator="parent"
                width="600"
            >
                <product-availability-form :id="product.id" @close-dialog="dialog = false">
                </product-availability-form>
            </v-dialog>
        </v-btn>
    </div>
</div>
</template>

<script setup>
import AvailabilityInfoNibblet from "./AvailabilityInfoNibblet.vue";
import {mdiMessageTextOutline, mdiTimerSandEmpty} from "@mdi/js";
import VueCountdown from "@chenfengyuan/vue-countdown/dist/vue-countdown.esm.js"
import ProductAvailabilityForm from "./ProductAvailabilityForm.vue";
import {ref} from "vue";

const props = defineProps({
    product: Object,
    time: Number
})

const dialog = ref(false);
const counting = ref(!!props.time)

</script>

<style scoped lang="scss">

</style>
